import React from 'react';

import HeaderImage from './index';

import Small from '../../../../assets/images/headers/contact/small.png'
import Big from '../../../../assets/images/headers/contact/big.png'

const ContactHeaderImage = (props: { width: number }) => (
    <HeaderImage width={props.width} small={Small} big={Big}/>
);

export default ContactHeaderImage
